module.exports = new __parcel__URL__("branch-creation-options-with-issue-key-highlight.6b1c37f4.png").toString();